
















import { GeekFullName } from '@/components';
import { GeekItemWithJobTitle } from '@/models';
import Vue from 'vue';

export default Vue.extend({
  name: 'AdminItem',
  components: {
    GeekFullName: () => Promise.resolve(GeekFullName),
  },
  props: {
    admin: Object as () => GeekItemWithJobTitle,
  },
});
